import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/devlist',
      children: [{
          path: '/devlist',
          component: () => import('@/views/devlist.vue'),
          name: '设备主页'
        },
        {
          path: '/group',
          component: () => import('@/views/grouppage.vue'),
          name: '分组主页'
        },
        {
          path: '/user',
          component: () => import('@/views/userpage.vue'),
          name: '用户主页'
        },
        {
          path: '/dev/DevPageKD5',
          component: () => import('@/components/kd5/DevPageKD5.vue'),
          name: 'KD5page'
        },
      ]
    },

    {
      path: '/KD1',
      name: 'KD1',
      component: () => import('@/components/kd1/KD1.vue'),
      redirect: '/main',
      children: [{
          path: 'main',
          component: () => import('@/components/kd1/DevPageKD1.vue'),
          name: 'KD1page'
        },
        {
          path: 'config',
          component: () => import('@/components/kd1/KD1Config.vue'),
          name: 'KD1Config'
        },
        {
          path: 'log',
          component: () => import('@/components/kd1/KD1Log.vue'),
          name: 'KD1Log'
        },
      ]
    },

    {
      path: '/KA1',
      name: 'KA1',
      component: () => import('@/components/ka1/KA1.vue'),
      redirect: '/main',
      children: [{
          path: 'main',
          component: () => import('@/components/ka1/DevPageKA1.vue'),
          name: 'KA1page'
        },
        {
          path: 'config',
          component: () => import('@/components/ka1/KA1Config.vue'),
          name: 'KA1Config'
        },
        {
          path: 'log',
          component: () => import('@/components/ka1/KA1Log.vue'),
          name: 'KA1Log'
        },
      ]
    },

    {
      path: '/KD2',
      name: 'KD2',
      component: () => import('@/components/kd2/KD2.vue'),
      redirect: '/main',
      children: [{
          path: 'main',
          component: () => import('@/components/kd2/DevPageKD2.vue'),
          name: 'KD2page'
        },
        {
          path: 'config',
          component: () => import('@/components/kd2/KD2Config.vue'),
          name: 'KD2Config'
        },
        {
          path: 'log',
          component: () => import('@/components/kd2/KD2Log.vue'),
          name: 'KD2Log'
        },
      ]
    },

    {
      path: '/KD3',
      name: 'KD3',
      component: () => import('@/components/kd3/KD3.vue'),
      redirect: '/main',
      children: [{
          path: 'main',
          component: () => import('@/components/kd3/DevPageKD3.vue'),
          name: 'KD3page'
        },
        {
          path: 'config',
          component: () => import('@/components/kd3/KD3Config.vue'),
          name: 'KD3Config'
        },
        {
          path: 'log',
          component: () => import('@/components/kd3/KD3Log.vue'),
          name: 'KD3Log'
        },
      ]
    },

    {
      path: '/KD6',
      name: 'KD6',
      component: () => import('@/components/kd6/KD6.vue'),
      redirect: '/main',
      children: [{
          path: 'main',
          component: () => import('@/components/kd6/DevPageKD6.vue'),
          name: 'KD6page'
        },
        {
          path: 'config',
          component: () => import('@/components/kd6/KD6Config.vue'),
          name: 'KD6Config'
        },
        {
          path: 'log',
          component: () => import('@/components/kd6/KD6Log.vue'),
          name: 'KD6Log'
        },
      ]
    },

    {
      path: '/KS1',
      name: 'KS1',
      component: () => import('@/components/ks1/KS1.vue'),
      redirect: '/main',
      children: [{
          path: 'main',
          component: () => import('@/components/ks1/DevPageKS1.vue'),
          name: 'KS1page'
        },
        {
          path: 'config',
          component: () => import('@/components/ks1/KS1Config.vue'),
          name: 'KS1Config'
        },
        {
          path: 'log',
          component: () => import('@/components/ks1/KS1Log.vue'),
          name: 'KS1Log'
        },
      ]
    },

    {
      path: '/KS2',
      name: 'KS2',
      component: () => import('@/components/ks2/KS2.vue'),
      redirect: '/main',
      children: [{
          path: 'main',
          component: () => import('@/components/ks2/DevPageKS2.vue'),
          name: 'KS2page'
        },
        {
          path: 'config',
          component: () => import('@/components/ks2/KS2Config.vue'),
          name: 'KS2Config'
        },
        {
          path: 'log',
          component: () => import('@/components/ks2/KS2Log.vue'),
          name: 'KS2Log'
        },
      ]
    },

    {
      path: '/KD4',
      name: 'KD4',
      component: () => import('@/components/kd4/KD4.vue'),
      redirect: '/main',
      children: [{
          path: 'main',
          component: () => import('@/components/kd4/DevPageKD4.vue'),
          name: 'KD4page'
        },
        {
          path: 'config',
          component: () => import('@/components/kd4/KD4Config.vue'),
          name: 'KD4Config'
        },
        {
          path: 'log',
          component: () => import('@/components/kd4/KD4Log.vue'),
          name: 'KD4Log'
        },
      ]
    },

    {
      path: '/login',
      component: () => import('@/views/login.vue'),
      name: 'login'
    },
    {
      path: '/register',
      component: () => import('@/views/register.vue'),
      name: 'register'
    },
    {
      path: '/passwordreset',
      component: () => import('@/views/passwordreset.vue'),
      name: 'passwordreset'
    }
  ]
})